<style lang="css" scoped>
a.btn.btn-success:hover {
    color: #ffffff !important;
    text-decoration: none;
    background-color: rgb(68, 0, 117,0.8)!important;
}
a#ok.btn.btn-success:hover {
    color: #ffffff !important;
    text-decoration: none;
    background-color: #218838!important;
}
th.bg-primary{
    background-color: #375c84!important;
}
h4.mb-0.text-light {
    font-size: 18px;
}
td.text-left.feature-td {
    font-weight: bolder;
}
div.jumbotron.marquee {
  background: #f5f5f5;
}
</style>

<style>
  .profile-area img {
    max-width: 150px;
    margin-bottom: 20px;
  }

  .panel-body h3 {
    margin-top: 0;
  }
button#request.btn.btn-outline-success {
    /*background-color:#544ccc;*/
    border-color:#544ccc;
    color: #544ccc;
    border-width: 2px;
    width: 100%;
}
button#request.btn.btn-outline-success:hover {
    color: #fff;
    background-color: #544ccc;
    border-color: #544ccc;
}
button#request.btn.btn-outline-success:focus{
    -webkit-box-shadow: 0 0 0 0.2rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.2rem rgb(84, 76, 204, 0.5);
}
button#request.btn.btn-success {
    background-color:#544ccc;
    border-color:#544ccc;
}
button#request.btn.btn-success:hover {
    color: #fff;
    background-color: #403a9c;
    border-color: #403a9c;
}
button#request.btn.btn-success:focus{
    -webkit-box-shadow: 0 0 0 0.2rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.2rem rgb(84, 76, 204, 0.5);
}
h1#info-page{
    font-size:45px;
    font-weight:300;
    height:54px;
    line-height:54px;
}
community.card.mb-2{
    border: 3px solid #bbbbbb;
}
hr#topline.my-4 {
    padding-top: 1px;
    margin-bottom: 1rem !important;
    margin-top: 1px !important;
}
.popup-big {
    text-align: center;
    color: #777;
    font-size: .98em;
    font-size:24px;
    font-weight:400;
    color:black;
}

.popup-small {
    text-align: center;
    color: #333;
    font-size:16px;
    font-weight: bold;
}
a#link:hover {
        color: #0056b3 !important;
        text-decoration: none;
}
button#unavailable-researcher.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#unavailable-pro.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#unavailable-automation.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#unavailable-volume.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#unavailable-researcher.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#unavailable-pro.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#unavailable-automation.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#unavailable-volume.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#active-researcher.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#active-pro.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#active-automation.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#active-volume.btn.btn-default:focus {
    -webkit-box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
    box-shadow: 0 0 0 0.0rem rgb(84, 76, 204, 0.5);
}
button#active-researcher.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#active-pro.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#active-automation.btn.btn-default {
    padding: 0px;
    border: 0px;
}
button#active-volume.btn.btn-default {
    padding: 0px;
    border: 0px;
}
a#signin:hover {
        color: rgb(48, 43, 117) !important;
        text-decoration: none;
        cursor: pointer;
}
</style>

<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">Plans and Pricing</h1>
            </div>
        </div>
        <hr class="my-4" id="topline" style="padding-top: 1px;">
        <template v-if="(authenticated && Object.keys(accessData).length) || !authenticated">
            <div class="row" style="padding-top: 15px;padding-bottom: 15px;">
                <template v-if="!isMobile()">
                    <b-col>
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Public" 
                            style="min-height: 500px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Public</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>10 Submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                            </b-card-text>
                            <template slot="footer">
                                <div style="font-weight:bold;">Free</div>
                                <div style="font-size: 10px;">Non-commercial use only</div>
                            </template>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Researcher" 
                            style="min-height: 500px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Researcher</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>50 Submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$15 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("pro") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise") ||
                                                    accessData.roles.includes("automation")
                                                    )'>
                                        <b-button id="unavailable-researcher" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-researcher" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("researcher")'>
                                        <b-button id="active-researcher" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-researcher" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestResearcherLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestResearcher()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestResearcherLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Pro" 
                            style="min-height: 500px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Pro</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>200 Submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                              <!--   <b-row>
                                    <b-col><br><i class="fa fa-share-alt-square"></i> Access to custom integrations </b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col><br><i class="fa fa-eye-slash"></i> Private submissions</b-col>
                                </b-row>
                                
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$80 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise") ||
                                                    accessData.roles.includes("automation") ||
                                                    accessData.roles.includes("researcher")
                                                    )'>
                                        <b-button id="unavailable-pro" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-pro" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("pro")'>
                                        <b-button id="active-pro" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-pro" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestProLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestPro()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestProLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Automation" 
                            style="min-height: 500px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Automation</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>5,000 Submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                              <!--   <b-row>
                                    <b-col><br><i class="fa fa-share-alt-square"></i> Access to custom integrations </b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col><br><i class="fa fa-eye-slash"></i> Private submissions</b-col>
                                </b-row>
                                
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$200 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise") ||
                                                    accessData.roles.includes("researcher") ||
                                                    accessData.roles.includes("pro")
                                                    )'>
                                        <b-button id="unavailable-automation" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-automation" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("automation")'>
                                        <b-button id="active-automation" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-automation" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestAutomationLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestAutomation()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestAutomationLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                </template>
                <template v-else>
                    <b-col style="min-width: 200px;padding-left: 5px;padding-right: 5px;padding-top: 15px;">
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Researcher" 
                            style="min-height: 400px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Researcher</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>50 submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$15 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("pro") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise")||
                                                    accessData.roles.includes("automation")
                                                    )'>
                                        <b-button id="unavailable-researcher" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-researcher" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("researcher")'>
                                        <b-button id="active-researcher" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-researcher" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestResearcherLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestResearcher()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestResearcherLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                    <b-col style="min-width: 200px;padding-left: 5px;padding-right: 5px;padding-top: 15px;">
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Pro" 
                            style="min-height: 400px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Pro</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>200 submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                              <!--   <b-row>
                                    <b-col><br><i class="fa fa-share-alt-square"></i> Access to custom integrations </b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col><br><i class="fa fa-eye-slash"></i> Private submissions</b-col>
                                </b-row>
                                
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$80 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise") ||
                                                    accessData.roles.includes("automation") ||
                                                    accessData.roles.includes("researcher")
                                                    )'>
                                        <b-button id="unavailable-pro" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-pro" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("pro")'>
                                        <b-button id="active-pro" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-pro" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestProLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestPro()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestProLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                    <b-col style="min-width: 200px;padding-left: 5px;padding-right: 5px;padding-top: 15px;">
                        <b-card 
                            text-variant="black" 
                            sub-title-text-variant="black"
                            header="Automation" 
                            style="min-height: 400px;border: 3px solid #bbbbbb;"
                            class="text-center">
                            <template slot="header">
                                <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Automation</h4></div>
                            </template>
                            <b-card-text>
                                <b-row>
                                    <b-col><b>5,000 submissions</b></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><hr style="background: white;"></b-col>
                                </b-row>
                                <b-row>
                                    <b-col><br><i class="fa fa-gears"></i> API access</b-col>
                                </b-row>
                              <!--   <b-row>
                                    <b-col><br><i class="fa fa-share-alt-square"></i> Access to custom integrations </b-col>
                                </b-row> -->
                                <b-row>
                                    <b-col><br><i class="fa fa-eye-slash"></i> Private submissions</b-col>
                                </b-row>
                                
                            </b-card-text>
                            <template slot="footer">
                                <template v-if="!authenticated">
                                    <div style="font-weight:bold; color: #544ccc;">
                                        <a id="signin" @click="auth.login()">Sign In</a>
                                    </div>
                                    <div style="font-size: 10px;">Sign in for more details</div>
                                </template>
                                <template v-else>
                                    <div style="font-weight:bold;">$200 monthly</div>
                                    <hr style="background: white;">
                                    <template v-if='Object.keys(accessData).length && 
                                                    (
                                                    accessData.roles.includes("admin") ||
                                                    accessData.roles.includes("partner") ||
                                                    accessData.roles.includes("enterprise") ||
                                                    accessData.roles.includes("pro") ||
                                                    accessData.roles.includes("researcher") 
                                                    )'>
                                        <b-button id="unavailable-automation" variant="default" v-on:click="" ref="button">
                                            <b>Unavailable</b>
                                            <div style="font-size: 10px;">You have an active plan.</div>
                                        </b-button>
                                        <b-tooltip target="unavailable-automation" triggers="hover">
                                            You must first cancel your existing plan before upgrading.
                                        </b-tooltip>
                                    </template>
                                    <template v-else-if='Object.keys(accessData).length &&
                                                        accessData.roles.includes("automation")'>
                                        <b-button id="active-automaton" variant="default" v-on:click="" ref="button">
                                            <b style="color:#27a744;">Active</b>
                                            <div style="font-size: 10px;">Manage plan in <a id="link" href="/account">account settings</a>.</div>
                                        </b-button>
                                        <b-tooltip target="active-automaton" triggers="hover">
                                            This plan is active for your account.
                                        </b-tooltip>
                                    </template>
                                    <template v-else>
                                        <template v-if="!requestAutomationLoading">
                                            <b-button id="request" variant="outline-success" v-on:click="requestAutomation()" ref="button">
                                                <b>Upgrade</b>
                                            </b-button>
                                        </template>
                                        <template v-else>
                                            <pulse-loader :loading="requestAutomationLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </b-card>
                    </b-col>
                </template>
            </div>
            <template v-if="!isMobile()">
                <div class="row" style="padding-left: 15px;padding-right: 15px;padding-top: 30px;padding-bottom: 15px;">
                    <b-card
                        title=""
                        img-top
                        style="max-width: 70rem;border: 3px solid #bbbbbb;"
                        class="mb-2"
                    >
                        <template slot="header">
                            <div style="text-align: center;"><h4 style="margin-bottom: 0px;">Volume Access</h4></div>
                        </template>
                        <b-card-sub-title class="mb-2">
                            <br>
                            Looking for higher volume access? We scale! With Volume Access you design a plan that fits your requirements. You can choose the volume you need, request a dedicated API for high volume low latency access, enable custom integrations, and more!
                            <br><br>
                            We also provide streamed access to our corpus of labeled, unpacked malware samples. Sample stream access includes full search across our samples and binary metadata. 
                            <br><br>
                        </b-card-sub-title>
                        <b-card-text>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-gears"></i></b-col><b-col>Dedicated high volume low latency API access</b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-eye-slash"></i></b-col><b-col>Private submissions</b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-share-alt-square"></i></b-col><b-col>Custom integrations</b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-users"></i></b-col><b-col>Group management for multiple users</b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-line-chart"></i></b-col><b-col>Realtime streamed access to our public labeled and unpacked sample corpus </b-col>
                            </b-row>
                            <br>
                            <b-row>
                                <b-col style="max-width: 10px;">&nbsp;</b-col><b-col style="max-width: 10px;"><i class="fa fa-search"></i></b-col><b-col>Full search and download access to our public sample corpus</b-col>
                            </b-row>
                        </b-card-text>
                        <template slot="footer">
                            <template v-if="!authenticated">
                                <div style="font-weight:bold; color: #544ccc;">
                                    <a id="signin" @click="auth.login()">Sign In</a>
                                </div>
                                <div style="font-size: 10px;">Sign in for more details</div>
                            </template>
                            <template v-else>
                                <b-row>
                                    <b-col style="max-width: 209px;">
                                        <b-button id="request" variant="outline-success" v-on:click="showVolume=true" ref="button">
                                            <b>Learn More</b>
                                        </b-button>
                                    </b-col>
                                    <b-col style="padding-left: 0px;">
                                        <!-- <div style="font-weight:bold;">Contact us</div> -->
                                        <!-- <div style="font-size: 10px;">Trial period available</div> -->
                                    </b-col>
                                </b-row>
                            </template>
                        </template>
                    </b-card>
                </div>
            </template>
            <div class="row" style="padding: 15px;">
                <b-card
                    title="Community Support"
                    img-top
                    style="max-width: 70rem;border: 3px solid #bbbbbb;"
                    class="mb-2"
                >
                    <b-card-sub-title class="mb-2">
                        <br>
                        UNPACME is dedicated to supporting initiatives that provide free services and information to the greater security community. 
                        If you run a public malware tracker, or maintain a free public malware analysis service, please contact us and let us know how we can help you.
                        <br><br>
                    </b-card-sub-title>
                    <b-card-text>
                        <b-button variant="outline-primary" target="_blank" href="mailto:unpacme@openanalysis.net" ref="button">
                            Contact Us
                        </b-button>
                    </b-card-text>
                </b-card>
            </div>
            <b-modal
                v-model="showResearcher"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Researcher Upgrade <img src="/static/img/rocket.png" alt="welcome" class="d-inline-block align-top" width="50" height="50" ></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                You now have access to <b>50</b> submissions a month!
                <br>
                </p>
                <br>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You can manage your plan settings from your <a id="link" href="/account">account</a> page.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <div style="text-align: center;"><b-btn id="ok" variant="success" href="/plans"  ><b style="font-size: 20px;font-weight: bold;">OK</b></b-btn></div>
                </b-jumbotron>
            </b-modal>
            <b-modal
                v-model="showPro"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Pro Upgrade <img src="/static/img/rocket.png" alt="welcome" class="d-inline-block align-top" width="50" height="50" ></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                You now have access to <b>200</b> submissions a month!
                <br>
                </p>
                <br>
                <p class="popup-big">
                Your plan also allows <b>private</b> submissions. 
                <br>
                <br>
                </p>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You can manage your plan settings from your <a id="link" href="/account">account</a> page.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <div style="text-align: center;"><b-btn id="ok" variant="success" href="/plans" ><b style="font-size: 20px;font-weight: bold;">OK</b></b-btn></div>
                </b-jumbotron>
            </b-modal>
            <b-modal
                v-model="showAutomation"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Automation Upgrade <img src="/static/img/rocket.png" alt="welcome" class="d-inline-block align-top" width="50" height="50" ></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                You now have access to <b>5,000</b> submissions a month!
                <br>
                </p>
                <br>
                <p class="popup-big">
                Your plan also allows <b>private</b> submissions. 
                <br>
                <br>
                </p>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                You can manage your plan settings from your <a id="link" href="/account">account</a> page.
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                <div style="text-align: center;"><b-btn id="ok" variant="success" href="/plans" ><b style="font-size: 20px;font-weight: bold;">OK</b></b-btn></div>
                </b-jumbotron>
            </b-modal>
            <b-modal
                v-model="showVolume"
                :centered="true"
                size="lg"
                header-bg-variant="light"
                header-text-variant="dark"
                :hideHeader="true"
                :hideFooter="true"
                :no-close-on-esc="true"
                :no-close-on-backdrop="true"
            >
                <b-jumbotron class="marquee" style="background-color: white; margin-bottom: 0px;">
                <template slot="header">
                    <div style="font-size: 45px;font-weight: 300;text-align: center;">Volume Access Information Request <br><i style="background-color:white;padding-right: 10px;padding-left: 10px;" class="fa fa-handshake-o "></i></div>
                </template>
                <hr class="my-4">
                <br>
                <p class="popup-big">
                Thank you for your interest!
                <br>
                </p>
                <br>
                <p class="popup-big">
                We will reach out to you at the following address <b>{{ profile.email }}</b> 
                <br>
                </p>
                <br>
                <b-row>
                <b-col>
                    &nbsp;
                </b-col>
                <b-col cols="9">
                <p class="popup-small">
                If this address is not correct please e-mail us directly <a id="link" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a> 
                </p>
                </b-col>
                <b-col>
                    &nbsp;
                </b-col>
                </b-row>
                <br><br>
                 <b-row>
                    <b-col>
                        &nbsp;
                    </b-col>
                    <b-col> 
                        <b-btn size="md" variant="dark" @click="showVolume=false" ><b style="font-size: 20px;font-weight: bold;">Cancel</b></b-btn>
                        <b-btn id="ok" variant="success" @click="requestVolume()" ><b style="font-size: 20px;font-weight: bold;">Request</b></b-btn></b-btn>
                    </b-col>
                    <b-col>
                        &nbsp;
                    </b-col>
                </b-row>
                </b-jumbotron>
            </b-modal>
        </template>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth', 'authenticated'],
    beforeCreate() {
        document.body.className = 'none';
    },
    data() {
        if (this.authenticated) {
            if (this.auth.userProfile) {
                this.$nextTick(() => {
                    this.profile = this.auth.userProfile;
                });
            } else {
                this.auth.getProfile((err, profile) => {
                    if (err) return console.log(err);
                    this.profile = profile;
                    return null;
                });
            }
        }
        return {
            profile: {},
            showResearcher: false,
            showPro: false,
            showAutomation: false,
            showVolume: false,
            plan: null,
            accessData: {},
            stripe: Stripe('pk_live_x1VEyNjpOupNBT7BGcEjCpJM005YveHCLX'),
            enterpriseEmail: "",
            requestResearcherLoading: false,
            requestProLoading: false,
            requestAutomationLoading: false,
        };
    },
    metaInfo() {
        return {
            title: 'UnpacMe Plans',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    notifications: {
        showErrorMsg: {
            type: 'error',
            title: 'ERROR',
            message: 'That\'s the error',
            timeout: 30000,
        },
    },
    methods: {
        getAccessData() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.accessData = res.data;
                })
                .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
                });
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            // ipad is a full browser
            // navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                console.log('is mobile');
                return true;
            }
            console.log('not mobile');
            return false;
        },
        requestVolume() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/contact/volume'
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    this.showVolume = false;
                })
                .catch((error) => {
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
        requestResearcher() {
            this.requestResearcherLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/account/checkout/researcher'
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    this.requestResearcherLoading = false;
                    this.stripe.redirectToCheckout({
                        sessionId: res.data.session_id
                    }).then(function (result) {
                      this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                    });
                })
                .catch((error) => {
                    this.requestResearcherLoading = false;
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
        requestPro() {
            this.requestProLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/account/checkout/pro'
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    this.requestProLoading = false;
                    this.stripe.redirectToCheckout({
                        sessionId: res.data.session_id
                    }).then(function (result) {
                      this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                    });
                })
                .catch((error) => {
                    this.requestProLoading = false;
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
        requestAutomation() {
            this.requestAutomationLoading = true;
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/account/checkout/automation'
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    this.requestAutomationLoading = false;
                    this.stripe.redirectToCheckout({
                        sessionId: res.data.session_id
                    }).then(function (result) {
                      this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                    });
                })
                .catch((error) => {
                    this.requestAutomationLoading = false;
                    this.showErrorMsg({ title: 'Request Failed', message: '<br>Our account services are currently offline. Please try again later, or email us directly at <a style="color:white;font-weight:bold;" href="mailto:unpacme@openanalysis.net">unpacme@openanalysis.net</a>' });
                });
        },
    },
    created() {
        // Display upgrade success if returned from checkout 
        if ( this.$route.query.upgrade === "pro") {
            this.showPro = true;
        }
        else if ( this.$route.query.upgrade === "researcher") {
            this.showResearcher = true;
        }
        else if ( this.$route.query.upgrade === "automation") {
            this.showAutomation = true;
        }
        if (this.authenticated) {
            this.getAccessData();
        }
    },
};
</script>




// WEBPACK FOOTER //
// src/components/Plans.vue